/***
 * File name: userExternalTable.js
 *
 * Program Description:
 * Table header configuration for the list of external users in the system
 *
 */
const externalTable = {
  admin: {
    userRole: 'admin',
    columns: [
      { value: 'fullName', text: 'Name', sortable: true, class: 'py-0 px-2', cellClass: 'py-0 px-2' },
      { value: 'email', text: 'Official DPO Email', sortable: true, class: 'py-0 px-2', cellClass: 'py-0 px-2' },
      { value: 'contactNumber', text: 'Contact No.', sortable: true, class: 'py-0 px-2', cellClass: 'py-0 px-2' },
      { value: 'sex', text: 'Sex', sortable: true, class: 'py-0 px-2', cellClass: 'py-0 px-2' },
      { value: 'organization', text: 'Organization', sortable: true, class: 'py-0 px-2', cellClass: 'py-0 px-2' },
      { value: 'dateCreated', text: 'Date Created', sortable: true, align: 'center', class: 'py-0 px-2', cellClass: 'py-0 px-2' },
      { value: 'status', text: 'Status', sortable: false, align: 'center', class: 'py-0 px-2', cellClass: 'py-0 px-2' },
      { value: 'actions', text: 'Actions', sortable: false, align: 'center', class: 'py-0 px-2', cellClass: 'py-0 px-2' }
    ]
  },
  roles: {
    columns: [
      { value: '_configType', text: 'Role', sortable: true },
      { value: 'dateCreated', text: 'Date Created', sortable: true },
      { value: 'actions', text: 'Actions', sortable: false, align: 'end' }
    ]
  },
  contact: {
    columns: [
      { value: 'email', text: 'Email', sortable: true },
      { value: 'landline', text: 'Landline', sortable: true },
      { value: 'fax', text: 'Fax', sortable: true },
      { value: 'cellphoneNumber', text: 'Mobile', sortable: true }
    ]
  }
}

export default externalTable
